import { OnSelectCallbackParam } from 'react-daterange-picker'

export const getFormattedDateRange = (value: OnSelectCallbackParam, dateFormat?: string) => {
  if (!value || !value.start || !value.end) return ''

  const DATE_FORMAT = dateFormat || 'DD/MM/YYYY'
  const startDate = value.start.format(DATE_FORMAT)
  const endDate = value.end.format(DATE_FORMAT)
  return `${startDate} - ${endDate}`
}
